import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './Card.scss';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Card = ({
  id,
  title,
  titleClassName = '',
  titleLink,
  titleLinkTo,
  titleExternal,
  titleExternalClassname = '',
  titleExternalLinkTo,
  titleLinkClassName = '',
  children,
  padded = true,
  backgroundClass = 'bg-white',
  headerBackgroundClass = 'bg-blue-dark',
  serviceRequestColor,
  waterConsumptionColor,
  headerGroupClassName = '',
  ActionComponent_bottom,
  ActionComponent_top,
  className = '',
  bodyClassName = '',
  loading = false,
  loadingText = 'Loading',

  // should be an array of components
  TabsComponent,
  ...rest
}) => {
  // construct header classes
  const headerClasses = classNames(
    `bg-blue-dark p-8 text-white text-xl uppercase flex justify-between items-center ${headerBackgroundClass}`,
    {
      // only add these classes if the background color is not white
      'border-primary border-b': backgroundClass !== 'bg-white',
    }
  );

  // construct body classes
  const bodyClasses = classNames(
    'flex flex-col items-stretch h-full',
    bodyClassName,
    {
      // if padded prop is true, add class p-8
      'p-8': padded,
    }
  );

  return (
    <div className={`p-2 ${className}`} id={id}>
      <div
        className={`flex flex-col card border border-primary w-full h-full ${backgroundClass}`}
        {...rest}
      >
        {title && (
          <div
            className={headerClasses}
            // style={{
            //   backgroundColor: `${
            //     serviceRequestColor
            //       ? '#0A6FBD'
            //       : waterConsumptionColor && '#0A6FBD '
            //   }`,
            // }}
          >
            <div className={`w-full ${headerGroupClassName}`}>
              {ActionComponent_top && ActionComponent_top}
              <div
                className={`${
                  titleLink || titleExternalLinkTo
                    ? `w-full flex justify-between items-center ${titleClassName}`
                    : `w-full flex justify-start items-center ${titleClassName}`
                }  `}
              >
                {title}
                {titleLink && (
                  <Link to={titleLinkTo} className={titleLinkClassName}>
                    {titleLink}
                  </Link>
                )}
                {titleExternalLinkTo && (
                  <a
                    className={titleExternalClassname}
                    href={titleExternalLinkTo}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {titleExternal}
                  </a>
                )}
              </div>
              {ActionComponent_bottom && ActionComponent_bottom}
            </div>
          </div>
        )}
        {loading ? (
          <div className="w-full flex items-center justify-center py-24">
            <Spin tip={loadingText} indicator={antIcon} />
          </div>
        ) : TabsComponent ? (
          TabsComponent
        ) : (
          <div className={bodyClasses}>{children}</div>
        )}
      </div>
    </div>
  );
};

export default Card;
